import i18n from "@/locales";

/**
 * 私募基金
 */
export default [
  {
    path: "/private-fund",
    redirect: "/private-fund/fundList"
  },
  {
    path: "/private-fund/fundList",
    name: "fundList",
    component: () => import("@/views/private-fund/fundList/index.vue"),
    meta: {
      showHeader: false,
      isH5Page: true,
      isH5Login: true,
      authFailToastOnly: true,
      title: i18n.t("privateFund.title")
    }
  },
  {
    path: "/private-fund/fundDetails",
    name: "fundDetails",
    component: () => import("@/views/private-fund/fundDetails/index.vue"),
    meta: {
      showHeader: false,
      isH5Page: true,
      isH5Login: true,
      authFailToastOnly: true,
      title: i18n.t("privateFund.title")
    }
  },
  {
    path: "/private-fund/fundSubscribe",
    name: "fundSubscribe",
    component: () => import("@/views/private-fund/fundSubscribe/index.vue"),
    meta: {
      showHeader: false,
      isH5Page: true,
      isH5Login: true,
      authFailToastOnly: true,
      title: i18n.t("privateFund.subscribe.title")
    }
  },
  {
    path: "/private-fund/fundOrder",
    name: "fundOrder",
    component: () => import("@/views/private-fund/fundOrder/index.vue"),
    meta: {
      showHeader: false,
      isH5Page: true,
      isH5Login: true,
      authFailToastOnly: true,
      title: i18n.t("privateFund.order.title")
    }
  }
];
